import {ListAccessAdministrationPermissionsQueryParams} from "@project/sdk/access-administration/zod";
import type {z} from "zod";

export const listPermissionsSearchSchema = ListAccessAdministrationPermissionsQueryParams.extend({
  page: ListAccessAdministrationPermissionsQueryParams.shape.page.catch(1).default(1),
  perPage: ListAccessAdministrationPermissionsQueryParams.shape.perPage.catch(20).default(20),
  q: ListAccessAdministrationPermissionsQueryParams.shape.q.catch(undefined),
});
export type ListPermissionsSearchInput = z.input<typeof listPermissionsSearchSchema>;
export type ListPermissionsSearch = z.output<typeof listPermissionsSearchSchema>;
